import type { EventMergeId } from "./Tracking";
import type { TrackingLabels } from "./TrackingLabels";
import { misc } from "@otto-ec/global-resources/misc";
import tracker from "./Tracker";

let eventMergeId: EventMergeId | undefined;

export function createEventMergeId() {
  if (eventMergeId) {
    console.warn("EventMergeId already defined");
  }
  eventMergeId = misc.guid();
  return eventMergeId;
}

export function deleteEventMergeId(): EventMergeId | undefined {
  const tmp = eventMergeId;
  eventMergeId = undefined;
  return tmp;
}

export function ensureEventMergeId(): EventMergeId {
  return eventMergeId || createEventMergeId();
}

export function submitEventTracking(tracking: Partial<TrackingLabels>, eventMergeId?: string) {
  if (eventMergeId) {
    tracker.addToEvent(tracking, eventMergeId);
  } else {
    tracker.submitEvent(tracking);
  }
}
